import React from 'react';
import { useAuthStore } from '../../lib/store-auth';
import { Sidebar } from './Sidebar';
import { SimulationGrid } from './SimulationGrid';
import { PastSessions } from './PastSessions';
import { Leaderboard } from './Leaderboard';
import { ModuleList } from '../modules/ModuleList';
import { ProfileAvatar } from '../profile/ProfileAvatar';
import './dashboard.scss';

import { Simulation, Module } from '../../lib/supabase';

import { useState } from 'react';

interface DashboardProps {
    onStartSimulation: (sim: Simulation) => void;
    onOpenSettings: () => void;
    onOpenProfile: () => void;
    onLogout: () => void;
    onOpenPastSessions: () => void;
    showPastSessions?: boolean;
    showLeaderboard?: boolean;
    showModules?: boolean;
    onBack?: () => void;
    onViewReport?: () => void;
    onOpenLeaderboard?: () => void;
    onOpenModules?: () => void;
    onStartModule?: (mod: Module) => void;
}

export const Dashboard: React.FC<DashboardProps> = ({
    onStartSimulation,
    onOpenSettings,
    onOpenProfile,
    onLogout,
    onOpenPastSessions,
    showPastSessions,
    showLeaderboard,
    showModules,
    onBack,
    onViewReport,
    onOpenLeaderboard,
    onOpenModules,
    onStartModule
}) => {
    const { user } = useAuthStore();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const activeTab = showPastSessions ? 'past-sessions' : showLeaderboard ? 'leaderboard' : showModules ? 'modules' : 'simulations';

    return (
        <div className="dashboard-layout">
            <Sidebar
                onOpenProfile={onOpenProfile}
                onOpenPastSessions={onOpenPastSessions}
                onOpenLeaderboard={onOpenLeaderboard}
                onOpenModules={onOpenModules}
                activeTab={activeTab}
                onOpenSimulations={onBack}
            />
            <main className="dashboard-main">
                <header className="dashboard-header">
                    <h1>
                        {showPastSessions ? 'Geçmiş Oturumlarım' :
                            showLeaderboard ? 'Liderlik Tablosu' :
                                showModules ? 'Modüller' : 'Simülasyonlar'}
                    </h1>
                    {user && (
                        <div className="header-profile-container" style={{ position: 'relative' }}>
                            <div className="header-profile" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                                <ProfileAvatar
                                    name={user.full_name || user.email}
                                    url={user.avatar_url}
                                    size="sm"
                                />
                                <span className="profile-name">{user.full_name || 'Kullanıcı'}</span>
                                <span className="material-symbols-outlined" style={{ fontSize: '20px', color: '#9ca3af' }}>expand_more</span>
                            </div>
                            {isMenuOpen && (
                                <div className="profile-dropdown-menu" style={{
                                    position: 'absolute',
                                    top: '100%',
                                    right: 0,
                                    background: 'white',
                                    border: '1px solid #e5e7eb',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                                    padding: '8px',
                                    marginTop: '8px',
                                    zIndex: 50,
                                    minWidth: '200px'
                                }}>
                                    <button onClick={() => { setIsMenuOpen(false); onOpenProfile(); }} style={{
                                        display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '8px 12px',
                                        border: 'none', background: 'transparent', cursor: 'pointer', textAlign: 'left', borderRadius: '4px',
                                        color: '#374151', fontSize: '14px', fontWeight: 500
                                    }}>
                                        <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>person</span>
                                        Profil Ayarları
                                    </button>
                                    <button onClick={() => { setIsMenuOpen(false); onLogout(); }} style={{
                                        display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '8px 12px',
                                        border: 'none', background: 'transparent', cursor: 'pointer', textAlign: 'left', borderRadius: '4px',
                                        color: '#ef4444', fontSize: '14px', fontWeight: 500
                                    }}>
                                        <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>logout</span>
                                        Çıkış Yap
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </header>
                <div className="simulation-content">
                    <div className="simulation-content">
                        {showPastSessions ? (
                            <PastSessions onBack={onBack || (() => { })} onViewReport={onViewReport} />
                        ) : showLeaderboard ? (
                            <Leaderboard />
                        ) : showModules ? (
                            <ModuleList onStartModule={onStartModule || (() => { })} />
                        ) : (
                            <SimulationGrid
                                onStartSimulation={onStartSimulation}
                                onOpenSettings={onOpenSettings}
                            />
                        )}
                    </div>
                </div>
            </main>
        </div>
    );
};

